import { render } from "./settings.vue?vue&type=template&id=12085eca"
const script = {}
script.render = render

export default script